import InactiveEnvironmentBanner from 'dashboard/components/InactiveEnvironmentBanner';
import {
  RoutedTabbedSectionCard,
  RoutedTabbedSectionSwitch,
} from 'dashboard/components/TabbedSectionV2';
import { Container, Header, Section } from 'dashboard/layouts/IndexViewLayoutV2';
import DashboardGettingStartedAPIRoute from 'dashboard/routes/DashboardGettingStartedAPIRoute';
import DashboardGettingStartedEmbeddedFlowRoute from 'dashboard/routes/DashboardGettingStartedEmbeddedFlowRoute';
import DashboardGettingStartedHostedFlowRoute from 'dashboard/routes/DashboardGettingStartedHostedFlowRoute';
import DashboardGettingStartedMobileSDKsRoute from 'dashboard/routes/DashboardGettingStartedMobileSDKsRoute';
import DashboardGettingStartedOverviewRoute from 'dashboard/routes/DashboardGettingStartedOverviewRoute';

const DashboardGettingStartedView = () => {
  return (
    <>
      <InactiveEnvironmentBanner />
      <Container>
        <Header title='Getting Started' />
        <Section>
          <RoutedTabbedSectionCard
            tabs={[
              {
                name: 'Overview',
                path: 'overview',
                dataTest: 'getting-started-view__tab--overview',
              },
              {
                name: 'Hosted Flow',
                path: 'hosted-flow',
                dataTest: 'getting-started-view__tab--hosted-flow',
              },
              {
                name: 'Embedded Flow',
                path: 'embedded-flow',
                dataTest: 'getting-started-view__tab--embedded-flow',
              },
              {
                name: 'Mobile SDKs',
                path: 'mobile-sdks',
                dataTest: 'getting-started-view__tab--mobile-sdks',
              },
              {
                name: 'Server APIs',
                path: 'api',
                dataTest: 'getting-started-view__tab--api-only',
              },
            ]}
          />
          <RoutedTabbedSectionSwitch
            tabs={[
              {
                path: 'overview',
                contents: <DashboardGettingStartedOverviewRoute />,
              },
              {
                path: 'hosted-flow',
                contents: <DashboardGettingStartedHostedFlowRoute />,
              },
              {
                path: 'embedded-flow',
                contents: <DashboardGettingStartedEmbeddedFlowRoute />,
              },
              {
                path: 'mobile-sdks',
                contents: <DashboardGettingStartedMobileSDKsRoute />,
              },
              {
                path: 'api',
                contents: <DashboardGettingStartedAPIRoute />,
              },
            ]}
          />
        </Section>
      </Container>
    </>
  );
};

export default DashboardGettingStartedView;
